import { request } from '../utils';
import { toast } from '../components';
import store from '../store';

export default function zan(data, list, calback, len?, num?) {
    cancelFollow(data, list, calback, len, num);
}

function cancelFollow(data: any, list, calback: any, len?: any, num?: any) {
    request('newproduct/carts/v1', {
        skuId: data.data,
        partnerId: store.user.partnerId,
        num: data.selectNumber
    }).then((rd) => {
        if (rd.errCode == 200) {
            calback && calback(false);
            if (len && num) {
                len - 1 === num && toast('加入购物车成功');
                len - 1 === num && store.user.shopNum();
                return;
            }
            toast('加入购物车成功');
            store.status.headZindex = 39
            store.user.shopNum();
        } else {
            calback && calback(true);
            toast(rd.errDesc);
        }
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/operates/addShop.ts